/**
 * aegis decorator
 * aegis.info('上报一条白名单日志，这两种情况这条日志才会报到后台：1、打开页面的用户在名单中；2、对应的页面发生了错误🤨');
 * aegis.infoAll('上报了一条日志，该上报与info唯一的不同就在于，所有用户都会上报');
 * aegis.report(new Error('上报一个错误'));
 * aegis.error(new Error('主动上报一个JS执行错误'));
 */

const aegis = window.qq_youth_aegis;

//  * aegis.info('上报一条白名单日志，这两种情况这条日志才会报到后台：1、打开页面的用户在名单中；2、对应的页面发生了错误🤨');
const info = (msg) => {
  aegis && aegis.info(msg);
}

// * aegis.infoAll('上报了一条日志，该上报与info唯一的不同就在于，所有用户都会上报');
const infoAll = (msg) => {
  aegis && aegis.infoAll(msg);
}

// * aegis.report(new Error('上报一个错误'));
const report = (msg) => {
  aegis && aegis.report(new Error(`rpErr:${msg}`));
}

// * aegis.error(new Error('主动上报一个JS执行错误'));
const error = (msg) => {
  aegis && aegis.error(new Error(`jsErr:${msg}`));
}

/**
 aegis.reportT({
  name: 'onload', // 自定义测速 name
  duration: 1000, // 自定义测速耗时(0 - 60000)
  ext1: 'test1',
  ext2: 'test2',
  ext3: 'test3',
  from: '' // 测速发生的页面地址，可不传
});
 * @param msg
 */
const reportT = (data) => {
  aegis && aegis.reportT(data);
}

export default {
  info,
  infoAll,
  report,
  error,
  reportT
};
